module.exports = __webpack_public_path__ + "static/NeueMontreal-Medium-3942068513f3b3723ac5bb392514e3c1.woff";